export default function ThemeResource(
  resource,
  textMainColor,
  textSecondaryColor,
  bgMainColor,
  bgSecondaryColor,
  mainPrice,
  secondaryPrice,
  mainPriceTextColor,
  secondaryPriceTextColor,
  hasDefaultStyles = false,
) {
  return {
    ...resource,
    textMainColor: textMainColor,
    textSecondaryColor: textSecondaryColor,
    bgMainColor: bgMainColor,
    bgSecondaryColor: bgSecondaryColor,
    mainPrice: mainPrice,
    secondaryPrice: secondaryPrice,
    mainPriceTextColor: mainPriceTextColor,
    secondaryPriceTextColor: secondaryPriceTextColor,
    hasDefaultStyles: hasDefaultStyles,
  };
}
